export default __webpack_public_path__ + "static/media/logo_text.adccadc6.svg";